import AuraScanImage from "@/assets/img/modal/aura_scan_v2.webp"
import { AURA_SCAN_REPORT_MODAL_V2_PLAN_ID } from "@/features/subscriptions/report-plan-codes"
import { ReportIds } from "@/features/today/config/reports-data"

import type { AppModalComponentProps } from "../config/modal-registry"
import { ReportPromoModalV2, type ReportPromoCopyV2 } from "./report-promo-modal-v2"

const COPY: ReportPromoCopyV2 = {
  reportId: ReportIds.AuraScan,
  planId: AURA_SCAN_REPORT_MODAL_V2_PLAN_ID,
  title: "Get Your Aura Scan Report",
  description:
    "Reveal the colors, energy patterns, and qualities that make your aura uniquely yours",
  image: AuraScanImage,
  imageClassName: "h-[290px]",
  imageContain: true,
}

export function ReportAuraScanModalV2(props: AppModalComponentProps) {
  return <ReportPromoModalV2 {...props} copy={COPY} />
}
